import { BaseNode } from './BaseNode';
import { useFlowName } from './useFlowName';

export function ForEachNode({
  data,
}: {
  data: { label: string; arrayExpression?: string; flowId?: string; alias?: string };
}) {
  const target = useFlowName(data.flowId);

  return (
    <BaseNode
      type="foreach"
      label={data.label}
      alias={data.alias}
      lines={[
        { text: data.arrayExpression, mono: true },
        { text: target ? `→ ${target}` : data.flowId ? undefined : 'No target flow selected' },
      ]}
    />
  );
}
